import { render, staticRenderFns } from "./ArchDiagram.vue?vue&type=template&id=3734d342&scoped=true"
import script from "./ArchDiagram.vue?vue&type=script&lang=js"
export * from "./ArchDiagram.vue?vue&type=script&lang=js"
import style0 from "./ArchDiagram.vue?vue&type=style&index=0&id=3734d342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734d342",
  null
  
)

export default component.exports